import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Typography } from '@mui/material';

export default function DateInput({label, value, onChange}) {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopDatePicker
                label="Date input"
                inputFormat="DD/MM/YYYY"
                value={value}
                onChange={value => onChange(value?.toISOString())}
                renderInput={({inputRef, inputProps, InputProps}) => (
                    <Box sx={{display: 'flex', alignItems: 'center', mt: 3, mb: 2}}>
                        <Typography component={'div'} marginRight={3}>{label}</Typography>
                        <TextField size={'small'} ref={inputRef} {...inputProps} />
                        {InputProps?.endAdornment}
                    </Box>
                )}
            />
        </LocalizationProvider>
    );
}
